import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css']
})
export class PaymentsComponent implements OnInit {

  constructor(private g: Globals) {
    this.g.page = "Payments";
  }

  ngOnInit() {
  }

}
